// Account institution: optional typed name (suggestions from connected banks
// and creditors) plus an optional creditor link.
import React, { useEffect, useState } from 'react';
import { bankFeedsAPI } from '../bank-feeds';

// Institution names of connected banks (Plaid), for suggestions.
export function useBankNames(selectedBusiness) {
  const [names, setNames] = useState([]);
  useEffect(() => {
    bankFeedsAPI.items()
      .then((r) => setNames([...new Set((r.data.items || []).map((i) => i.institution_name).filter(Boolean))]))
      .catch(() => setNames([]));
  }, [selectedBusiness]);
  return names;
}

export function InstitutionFields({ institution, creditors, bankNames, creditorId, onCreditorChange, error }) {
  const suggestions = [...new Set([...(bankNames || []), ...(creditors || []).map((c) => c.creditor_name)])];
  return (
    <>
      <label className="block text-sm font-medium mb-1" htmlFor="account-institution">
        Institution <span className="text-gray-400 font-normal">(optional)</span>
      </label>
      <input
        id="account-institution"
        type="text"
        name="institution"
        list="account-institution-names"
        maxLength={255}
        defaultValue={institution}
        placeholder="Bank or lender name"
        className="w-full border rounded px-3 py-2"
      />
      <datalist id="account-institution-names">
        {suggestions.map((name) => <option key={name} value={name} />)}
      </datalist>
      <label className="block text-xs font-medium text-gray-600 mt-2 mb-1" htmlFor="account-creditor">
        Link to a creditor (optional)
      </label>
      <select
        id="account-creditor"
        name="creditor_id"
        value={creditorId}
        onChange={(e) => onCreditorChange(e.target.value)}
        className="w-full border rounded px-3 py-2"
      >
        <option value="">No creditor</option>
        {(creditors || []).map((c) => <option key={c.id} value={c.id}>{c.creditor_name}</option>)}
      </select>
      <p className="text-xs text-gray-500 mt-1">
        Checking, savings and bank cards can just name the bank. Link a creditor for loans and bills you track there.
      </p>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </>
  );
}
